import { publish as Publish } from './Libraries/RXjs/PubSub'

export const publish      = async(topic, data)  => Publish(topic, data);
export const roundDecimal = (num, decimals)     => Number(Math.round(num + "e" + decimals) + "e-" + decimals);
export const randomString = (length = 8)        => Math.random().toString(16).substring(2, length);
export const sleep        = (milliseconds)      => { new Promise(resolve => setTimeout(resolve, milliseconds)); };